// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB2Pvg8Ji9YaTdCHJAM18GD-NQrRGEZ3CE",
  authDomain: "portfolioljk.firebaseapp.com",
  projectId: "portfolioljk",
  storageBucket: "portfolioljk.appspot.com",
  messagingSenderId: "917284622710",
  appId: "1:917284622710:web:f579000e2d163eee62aa57",
  measurementId: "G-9VCFEF2BVJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);